// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__haD9s","hidden":"hidden__30-5p","burgerOpen":"burgerOpen__vXQtl","burgerClose":"burgerClose__HHiz-","light":"light__Gl9sK","dark":"dark__p6uLa"};